function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { StyledIcon } from '../StyledIcon';
export var Safe = function Safe(props) {
  return React.createElement(StyledIcon, _extends({
    viewBox: "0 0 40 40",
    a11yTitle: "Safe"
  }, props), React.createElement("style", {
    type: "text/css"
  }), React.createElement("g", null, React.createElement("path", {
    d: "M35.5,6h-31C4.2,6,3.9,6.3,3.9,6.6v24.9c0,0.3,0.3,0.6,0.6,0.6H8v1.3C8,33.7,8.3,34,8.6,34h3.7c0.3,0,0.6-0.3,0.6-0.6v-1.3 h14.3v1.3c0,0.3,0.3,0.6,0.6,0.6h3.7c0.3,0,0.6-0.3,0.6-0.6v-1.3h3.5c0.3,0,0.6-0.3,0.6-0.6V6.6C36.1,6.3,35.8,6,35.5,6z M34.9,30.9h-3.5c-0.3,0-0.6,0.3-0.6,0.6v1.3h-2.5v-0.7h0.6c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6h-1.2c0,0,0,0,0,0c0,0,0,0,0,0 H12.3c-0.3,0-0.6,0.3-0.6,0.6v1.3H9.2v-0.7h0.6c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6H8.6H5.1V7.2h29.8V30.9z"
  }), React.createElement("path", {
    d: "M8,28.8H32c0.3,0,0.6-0.3,0.6-0.6V9.9c0-0.3-0.3-0.6-0.6-0.6H8c-0.3,0-0.6,0.3-0.6,0.6v2c0,0.3,0.3,0.6,0.6,0.6 c0.3,0,0.6-0.3,0.6-0.6v-1.4h22.9v17.1H8.6v-1.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6v2C7.4,28.5,7.6,28.8,8,28.8z"
  }), React.createElement("path", {
    d: "M22.2,19.2c0-3.3-2.7-6-6-6c-3.3,0-6,2.7-6,6c0,3.3,2.7,6,6,6C19.6,25.2,22.2,22.5,22.2,19.2z M11.5,19.2 c0-2.6,2.2-4.8,4.8-4.8c2.6,0,4.8,2.2,4.8,4.8c0,2.6-2.2,4.8-4.8,4.8C13.6,24,11.5,21.9,11.5,19.2z"
  }), React.createElement("path", {
    d: "M16.9,23v-1c0.3-0.1,0.6-0.2,0.9-0.4l0.7,0.7c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.8 l-0.7-0.7c0.2-0.3,0.3-0.6,0.4-0.9l1,0h0c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6l-1,0c-0.1-0.3-0.2-0.6-0.4-0.9l0.7-0.7 c0.2-0.2,0.2-0.6,0-0.8c-0.2-0.2-0.6-0.2-0.8,0l-0.7,0.7c-0.3-0.2-0.6-0.3-0.9-0.4v-1c0-0.3-0.3-0.6-0.6-0.6 c-0.3,0-0.6,0.3-0.6,0.6v1c-0.3,0.1-0.6,0.2-0.9,0.4L14,16.2c-0.2-0.2-0.6-0.2-0.8,0c-0.2,0.2-0.2,0.6,0,0.8l0.7,0.7 c-0.2,0.3-0.3,0.6-0.4,0.9l-1,0c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6l1,0c0.1,0.3,0.2,0.6,0.4,0.9l-0.7,0.7 c-0.2,0.2-0.2,0.6,0,0.8c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2l0.7-0.7c0.3,0.2,0.6,0.3,0.9,0.4v1c0,0.3,0.3,0.6,0.6,0.6 C16.6,23.6,16.9,23.3,16.9,23z M14.7,19.2c0-0.9,0.7-1.6,1.6-1.6c0.4,0,0.8,0.2,1.1,0.5c0,0,0,0,0,0c0,0,0,0,0,0 c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1c0,0,0,0,0,0c0,0,0,0,0,0c-0.3,0.3-0.7,0.5-1.1,0.5C15.4,20.8,14.7,20.1,14.7,19.2z "
  }), React.createElement("path", {
    d: "M27.4,23.3c0.3,0,0.6-0.3,0.6-0.6l0-3.5c1-0.3,1.7-1.2,1.7-2.2c0-1.3-1-2.3-2.3-2.3c-1.3,0-2.3,1-2.3,2.3 c0,1.1,0.7,2,1.7,2.2l0,3.5C26.8,23.1,27.1,23.3,27.4,23.3z M26.3,17c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1 c0,0.6-0.5,1.1-1.1,1.1C26.8,18.1,26.3,17.6,26.3,17z"
  }), React.createElement("path", {
    d: "M8,18c0.3,0,0.6-0.3,0.6-0.6v-3.5c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6v3.5C7.4,17.7,7.6,18,8,18z"
  }), React.createElement("path", {
    d: "M8,24.8c0.3,0,0.6-0.3,0.6-0.6v-3.5c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6v3.5C7.4,24.5,7.6,24.8,8,24.8z"
  })));
};